"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconLogout = void 0;
var _react = _interopRequireDefault(require("react"));
var _SvgWrapper = require("b2b-components/core/components/Icon/Icon/SvgWrapper");
const IconLogout = props => /*#__PURE__*/_react.default.createElement(_SvgWrapper.SvgWrapper, props, /*#__PURE__*/_react.default.createElement("path", {
  d: "M18.76 13.175H8.042v-2.15h10.72l-1.52-1.52 1.504-1.584 4.154 4.154-4.154 4.154-1.504-1.535 1.52-1.519ZM13.842 8.64V4.95H4.464v14.3h9.377v-3.69h2.15v5.84H2.315V2.8h13.678v5.84h-2.15Z"
}));
exports.IconLogout = IconLogout;
//# sourceMappingURL=IconLogout.js.map